<template>
  <div class="modal-shadow saved_popup min-h-screen flex flex-col" @click.self="close">
    <div class="inner">
      <div class="content">
        <div class="w-full flex justify-between modal_header p-6 title_line">
          <div class="modal_title mt-2">Route Import Example</div>
          <button type="button" class="x_btn" @click="close">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>

        <div class="modal_body flex flex-col px-6 pb-6 pt-2">
          <p class="text-grey-dark text-sm mb-4">
            Each non-empty row is one route. Column
            <code class="text-xs">start</code> is required;
            <code class="text-xs">departure</code> is optional (empty uses current
            date and time). Up to 50 stops via
            <code class="text-xs">start</code> and
            <code class="text-xs">location1</code>…<code class="text-xs">location49</code>.
          </p>

          <div v-if="loadError" class="text-red-600 text-sm mb-4">
            {{ loadError }}
          </div>
          <div v-else-if="loading" class="text-grey-dark text-sm py-8 text-center">
            Loading example…
          </div>
          <div v-else class="grid-wrap border rounded overflow-auto max-h-96 mb-4">
            <table class="w-full text-xs import-grid">
              <thead>
                <tr class="border-b bg-gray-50 sticky top-0">
                  <th
                    v-for="header in displayHeaders"
                    :key="'h-' + header"
                    class="p-2 text-left whitespace-nowrap"
                  >
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, idx) in previewRows"
                  :key="'row-' + idx"
                  class="border-b"
                >
                  <td
                    v-for="header in displayHeaders"
                    :key="'c-' + idx + '-' + header"
                    class="p-2 text-left whitespace-nowrap max-w-xs truncate"
                    :title="cellDisplay(row, header)"
                  >
                    {{ cellDisplay(row, header) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="flex justify-end gap-3">
            <button type="button" class="btn white-green px-6" @click="close">
              Close
            </button>
            <a
              :href="samplePath"
              :download="templateDownloadFilename"
              class="btn green-white px-6 inline-flex items-center"
              @click="onDownloadTemplate"
            >
              Download Example
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parseFile from 'vue-xls-csv-parser/src/parser';
import {
  ROUTES_IMPORT_EXAMPLES_PATH,
  ROUTES_IMPORT_TEMPLATE_FILENAME,
} from '@/constants/routesImport';
import {
  dedupeRoutePlannerDisplayHeaders,
  displayCellValue,
  orderRoutePlannerDisplayHeaders,
  routePlannerFileJsonToRawRows,
} from '@/utils/routesRoutePlannerCsv';

export default {
  name: 'RoutesImportTemplateModal',
  data() {
    return {
      samplePath: ROUTES_IMPORT_EXAMPLES_PATH,
      templateDownloadFilename: ROUTES_IMPORT_TEMPLATE_FILENAME,
      loading: true,
      loadError: '',
      previewRows: [],
      displayHeaders: [],
    };
  },
  async mounted() {
    try {
      const res = await fetch(this.samplePath);
      if (!res.ok) {
        throw new Error('Could not load template');
      }
      const blob = await res.blob();
      const file = new File([blob], 'routes-import-examples.csv', {
        type: 'text/csv',
      });
      const fileJson = await parseFile(file, 'en');
      const rawRows = routePlannerFileJsonToRawRows(fileJson);
      if (!rawRows.length) {
        this.loadError = 'Template file has no example rows.';
        return;
      }
      this.displayHeaders = dedupeRoutePlannerDisplayHeaders(
        orderRoutePlannerDisplayHeaders(Object.keys(rawRows[0] || {})),
      );
      this.previewRows = rawRows;
    } catch (e) {
      console.error(e);
      this.loadError = 'Could not load template preview.';
    } finally {
      this.loading = false;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onDownloadTemplate() {
      this.$nextTick(() => {
        this.close();
      });
    },
    cellDisplay(row, header) {
      return displayCellValue(row, header);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-shadow {
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.39);
  z-index: 404;
}
.modal_header {
  border-radius: 8px 8px 0 0;
  border-bottom: none;
}
.saved_popup {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100vw;
}
.inner {
  margin: 24px auto;
  max-width: min(1200px, 96vw);
  background: #fff;
  border-radius: 8px;
}
.import-grid th,
.import-grid td {
  text-align: left;
  vertical-align: top;
}
</style>
